import api, { API } from '../utils/api.utils';

interface AddUniversityRequest {
  university_id: number;
  status: 'PENDING';
  is_suggested: boolean;
}

interface UserUniversityResponse {
  id: number;
  university_id: number;
  user_id: number;
  status: string;
  is_suggested: boolean;
}

export const addUniversityToList = async (universityId: number): Promise<UserUniversityResponse> => {
  const requestData: AddUniversityRequest = {
    university_id: universityId,
    status: 'PENDING',
    is_suggested: false
  };

  const response = await api.post(`${API.USER_UNIVERSITIES_CRUD}/`, requestData);
  return response.data;
};

export const removeUniversityFromList = async (universityId: number): Promise<void> => {
  await api.delete(`${API.USER_UNIVERSITIES_CRUD}/${universityId}`);
};
